import * as tslib_1 from "tslib";
import * as React from 'react';
import ConversationsFull from './components/ConversationsFull';
import ConversationsQuick from './components/ConversationsQuick';
import isConversationsOptionDirty from './utils/isConversationsOptionDirty';
import discardConversationsOption from './actions/discardConversationsOption';
import { saveConversationsOptionFull } from './actions/saveConversationsOption';
var ConversationsOption = {
    key: 'conversations',
    titleStringKey: 'optionTitle_conversations',
    searchTermsStringKey: 'optionTitle_conversations',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ConversationsFull, null); },
        isDirty: isConversationsOptionDirty,
        onSave: saveConversationsOptionFull,
        onDiscard: discardConversationsOption,
    },
    quickOptionSettings: {
        rendering: {
            render: function (props) { return (React.createElement(ConversationsQuick, tslib_1.__assign({}, props))); },
        },
        order: 2 /* Conversations */,
        workloads: 1 /* Mail */,
        customTitle: 'options_conversations_quick_label',
        tooltip: {
            tooltipStringKey: 'options_conversations_quick_tooltip',
            shouldHideTooltip: function () { return false; },
        },
    },
};
export default ConversationsOption;
//# sourceMappingURL=ConversationsOption.js.map